export const SET_ACTIVE_LAYER = 'SET_ACTIVE_LAYER';

export const BULK_SET_ACTIVE_TABS = 'BULK_SET_ACTIVE_TABS';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const TOGGLE_ACTIVE_TAB = 'TOGGLE_ACTIVE_TAB';
export const RESET_ACTIVE_TABS = 'RESET_ACTIVE_TABS';

export const FILTERS_SET = 'FILTERS_SET';
export const FILTER_ADDED = 'FILTER_ADDED';
export const FILTER_REMOVED = 'FILTER_REMOVED';
export const CROP_ACTIVE = 'CROP_ACTIVE';
export const CROP_DEACTIVE = 'CROP_DEACTIVE';
export const SET_MAP_IMAGE_URL = 'SET_MAP_IMAGE_URL';
export const TOGGLE_CROP_ACTIVE = 'TOGGLE_CROP_ACTIVE';
export const SET_MAP_ZOOM = 'SET_MAP_ZOOM';
export const SET_MAP_LAST_CENTER = 'SET_MAP_LAST_CENTER';
export const SET_MAP_VISUAL_SETTINGS = 'SET_MAP_VISUAL_SETTINGS';
export const SET_MAP_VIEW_STATE = 'SET_MAP_VIEW_STATE';
export const SET_AVAILABLE_LAYERS = 'SET_AVAILABLE_LAYERS';
